import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Timeline } from '@navi/web-ui/lib/primitives';
import { CircularLoaderIcon } from '@navi/web-ui/lib/icons';
import { RootState } from '@cp/src/store';
import { readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { FIELD_ALLOCATION_KEY } from '../../../types';
import { fetchSingleMockRunDetails } from '../../../actions/FieldAllocationAction';
import { getTimelineData } from '../utils';
import EmptyState from './EmptyState';

const MockDetailsTimeline = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = readQueryParams(location?.search);
  const selectedMockId = queryParams[FIELD_ALLOCATION_KEY]?.selectedId;

  const mockRunsListMap =
    useSelector((state: RootState) => state?.fieldAllocation?.mockRunsMap) || {};
  const fieldAllocationStatusLoading = useSelector(
    (state: RootState) => state?.fieldAllocation?.fieldAllocationStatusLoading
  );

  const mockRunsListLoading = useSelector(
    (state: RootState) => state?.fieldAllocation?.mockRunsListLoading
  );
  const fieldAllocationDetails = useSelector(
    (state: RootState) => state?.fieldAllocation?.fieldAllocationDetails
  );
  const inputPreparationData = fieldAllocationDetails?.inputPreparationData;

  useEffect(() => {
    if (selectedMockId) {
      dispatch(fetchSingleMockRunDetails(selectedMockId));
    }
  }, [selectedMockId]);

  if (fieldAllocationStatusLoading || mockRunsListLoading) {
    return (
      <div className="h-full flex items-center justify-center">
        <CircularLoaderIcon size="lg" />
      </div>
    );
  }

  if (Object.keys(mockRunsListMap)?.length === 0) {
    return <EmptyState message="Initiate a mock to see the status" />;
  }

  if (!selectedMockId) {
    return <EmptyState message="Select a mock to see the status" />;
  }

  if (selectedMockId !== fieldAllocationDetails?.allocationTrackerId || !inputPreparationData)
    return <EmptyState message="No data found!" />;

  return (
    <div className="mt-5 ml-5 mr-6">
      <Timeline data={getTimelineData(fieldAllocationDetails, false)} />
    </div>
  );
};

export default MockDetailsTimeline;
